<template>
  <div class="survey-info" v-if="surveyInfo">
    <div>
      <div>
        <span style="font-size: 16px; font-weight: bolder; line-height: 35px">
          编号:{{ surveyInfo.guid }}
        </span>
      </div>
      <div>
        <span> 当前状态: </span>
        <span
          class="survey-status"
          :style="{
            backgroundColor: getStatusColor(),
            color: '#ffffff',
          }"
          v-if="getStatusLabel()"
        >
          {{ getStatusLabel() }}
        </span>
      </div>
      <div v-if="surveyInfo.surveyTitle">
        <div class="wordwrap">
          调研标题:
          <span>
            {{ surveyInfo.surveyTitle }}
          </span>
        </div>
      </div>
      <div v-if="surveyInfo.createTime > 0">
        <span>
          创建时间:
          {{ new Date(surveyInfo.createTime).format("YYYY-MM-dd hh:mm:ss") }}
        </span>
      </div>
      <div v-if="surveyInfo.arrangedGuid">
        <span>计划单号: {{ surveyInfo.arrangedGuid }}</span>
      </div>
      <div v-if="surveyInfo.storeInfo">
        <span>调研门店: {{ surveyInfo.storeInfo.name }}</span>
      </div>
      <div v-if="surveyInfo.handledBy">
        经手人员:
        <span>{{ surveyInfo.handledBy }}</span>
      </div>
    </div>
    <div label="备注信息" v-if="surveyInfo.optRemark">
      <div class="wordwrap">
        备注信息:
        <span class="survey-remark">{{ surveyInfo.optRemark }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.survey-remark {
  font-weight: bolder;
  line-height: 30px;
  color: #000000;
}

.survey-item-list {
  background: #fafafa;
  margin-top: 10px;
  padding: 10px;

  .item-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .item-count {
    font-size: 14px;
  }
}

.survey-status {
  width: auto;
  padding: 2px 5px;
  background-color: #ffffff;
  font-weight: 400;
  margin-right: 5px;
  border-radius: 5px;
  font-size: 14px;
  color: #5c5c5c;
}
</style>

<script>
export default {
  props: {
    showCount: {
      type: Boolean,
      default: false,
    },
    surveyInfo: {
      type: Object,
    },
  },
  methods: {
    getStatusColor() {
      if (this.surveyInfo.optStatus == 0) {
        return "#E6A23C";
      } else if (this.surveyInfo.optStatus == 1) {
        return "#6F88A1";
      } else if (this.surveyInfo.optStatus == 2) {
        return "#67C23A";
      } else if (this.surveyInfo.optStatus == 3) {
        return "#F56C6C";
      }
      return "#919191";
    },
    getStatusLabel() {
      if (this.surveyInfo.optStatus == 0) {
        return "待调研的";
      } else if (this.surveyInfo.optStatus == 1) {
        return "已完成的";
      } else if (this.surveyInfo.optStatus == 2) {
        return "部分完成";
      } else if (this.surveyInfo.optStatus == 3) {
        return "已关闭的";
      }
      return "";
    },
  },
};
</script>
